import { Account } from 'views/account';
import { Profile } from 'views/account/profile';
import { Billing } from 'views/account/billing';
// import { Upgrade } from 'views/account/upgrade';
import { Users } from 'views/account/users';
import { Password } from 'views/account/password';
import { TwoFA } from 'views/account/2fa';
import { APIKeyList } from 'views/account/apikey/list';
import { APIKeyEditor } from 'views/account/apikey/edit';
import { AccountHierarchy } from '../views/account/accountHierarchy';
import { LearningPath } from '../views/account/LearningPath';
import { Upgrade } from 'views/account/upgrade';

const Routes = [
  {
    path: '/account',
    view: Account,
    layout: 'app',
    permission: 'account.view',
    title: 'account.index.title'
  },
  {
    path: '/account/profile',
    view: Profile,
    layout: 'app',
    permission: 'account.profile.view',
    title: 'account.profile.title'
  },
  {
    path: '/account/password',
    view: Password,
    layout: 'app',
    permission: 'account.password.view',
    title: 'account.password.title'
  },
  {
    path: '/account/2fa',
    view: TwoFA,
    layout: 'app',
    permission: 'account.2fa.view',
    title: 'account.2fa.title'
  },
  {
    path: '/account/billing',
    view: Billing,
    layout: 'app',
    permission: 'account.orgbilling.view',
    title: 'account.billing.title'
  },
  {
    path: '/account/upgrade',
    view: Upgrade,
    layout: 'app',
    permission: 'account.upgrade.view',
    title: 'account.upgrade.title'
  },
  {
    // permission to manage users
    path: '/account/users',
    view: Users,
    layout: 'app',
    permission: 'account.users.view',
    title: 'account.users.title'
  },
  {
    path: '/account/apikeys',
    view: APIKeyList,
    layout: 'app',
    permission: 'account.apikeys.view',
    title: 'account.api_keys.title'
  },
  {
    path: '/account/apikeys/create',
    view: APIKeyEditor,
    layout: 'app',
    permission: 'account.apikeys.view',
    title: 'account.api_keys.title'
  },
  {
    path: '/account/apikeys/edit',
    view: APIKeyEditor,
    layout: 'app',
    permission: 'account.apikeys.view',
    title: 'account.api_keys.title'
  },
  {
    path: '/account/hierarchy',
    view: AccountHierarchy,
    layout: 'app',
    permission: 'account.hierarchy.view',
    title: 'account.hierarchy.title'
  },
  {
    path: '/account/lpath',
    view: LearningPath,
    layout: 'app',
    permission: 'account.lpath.view',
    title: 'account.LearningPath.title'
  }
]

export default Routes;
